<template>
  <div class="blog-detail-container">
    <w-nav-bar :nav_title="blogDetail.title" :icon="isWxMini && needShare ? '' : 'iconchevron-left '" @mobileLeftBtn="pageBack">
      <div slot="rightContent" @click="changeWxState">
        <span class="iconfont iconfenxiang1"></span>
      </div>
    </w-nav-bar>
    <img class="title-image" :src="blogDetail.title_img" alt="">
    <div class="blog-detail-content">
      <h1 class="blog-detail-title">{{ blogDetail.title }}</h1>
      <div class="detail-info flex-start">
        <span class="detail-time">{{ blogDetail.publish_at | timeFilter('YYYY-MM-DD') }}</span>
        <span class="detail-time" :class="{'detail-author': blogDetail.author_url}" @click="toAuthorDetail">{{ blogDetail.author }}</span>
      </div>
      <div class="blog-detail-description" v-html="blogDetail.content"></div>
    </div>
    <div class="flex-between community-detail-topic" @click="$router.replace('/community?currentTab=0')">
      <div class="flex-start">
        <img src="https://prod-file-uploaded.oss-cn-beijing.aliyuncs.com/bbs/1f9747b0-f268-11ea-b1a7-9583858d9ef8.png" alt="">
        <div class="topic-info flex-column">
          <span class="title">查看更多攻略</span>
          <span class="community-num">19524人查看过</span>
        </div>
      </div>
      <div class="topic-detail flex-center">去看看</div>
    </div>
    <div class="blog-hot-pages">
      <h1 class="hot-page-title">热门文章</h1>
      <template v-for="(item, index) in hotPages">
        <blog-item :key="index" :data="item" item-type="detail"></blog-item>
      </template>
    </div>
    <div class="blog-footer footer flex-center" v-if="blogDetail.my_status">
      <div class="footer-item flex-center" @click="blogCollect">
        <span class="iconfont" :class="blogDetail.my_status.has_collected ? 'iconyishoucang1' : 'iconweishoucang'"></span>
        <span>{{ '收藏' }}</span>
      </div>
      <div class="footer-item flex-center" @click="blogLike">
        <span class="iconfont" :class="blogDetail.my_status.has_liked ? 'icondianzan1' : 'iconweidianzan1'"></span>
        <span>{{ blogDetail.like_count || '点赞' }}</span>
      </div>
      <div class="footer-item flex-center" @click="changeWxState">
        <span class="iconfont iconfenxiang1"></span>
        <span>分享</span>
      </div>
    </div>
    <w-share-wx :state="wxState" @handleClose="changeWxState"/>
  </div>
</template>

<script>
	import WNavBar from '../../../components/global/w-navbar'
	import blogItem from '../components/blog-item'
	import WShareWx from '../../../components/global/w-share-wx'
	import { envMixin, loginMixin } from '../../../assets/js/mixin/global'
	import { communityMixin } from '../../../assets/js/mixin/community'
  import { componentsMixin } from '../../../assets/js/mixin/components'


  export default {
		name: 'blog-detail',
		mixins: [ envMixin, communityMixin, loginMixin, componentsMixin ],
		data () {
			return {
				blogDetail: {},
				hotPages: [],
				wxState: false
			}
		},
		mounted () {
			this.changeNeedShareValue()
			this.getBlogDetail(this.$route.params.token)
			this.getHotPages()
		},
		beforeRouteUpdate (to, from, next) {
			this.getBlogDetail(to.params.token)
			this.getHotPages()
			window.scrollTo(0, 0)
			next()
		},
		computed: {},
		watch: {},
		components: {
			WNavBar,
			blogItem,
			WShareWx
		},
		methods: {
			// 页面返回事件
			pageBack () {
				if (this.isWxMini && this.needShare) {
					this.$wechat.miniProgram.navigateBack()
				} else if (this.isWxMini) {
					this.$wechat.miniProgram.reLaunch({
            url: `/pages/community-list/community-list?url=${ process.env.VUE_APP_HOST }/community`
          })
        } else {
					this.$router.back()
				}
			},
			toAuthorDetail () {
				window.location.href = this.blogDetail.author_url
			},
			changeWxState () {
				this.wxState = !this.wxState
			},
			// 收藏
			async blogCollect () {
				if (!this.alreadyLogged) {
				  this.needLogin()
        } else {
					let { token } = this.$route.params
					let { my_status } = this.blogDetail
					let res = await this.$api.blog.updateBlogCollect(token, { is_collect: !my_status.has_collected })
					if (res.code === 1000) {
            if (my_status.has_collected){
              this.showToast('已取消收藏',1500);
            }else {
              this.showToast('已收藏',1500);
            }
						my_status.has_collected = !my_status.has_collected
					}
        }
			},
			// 点赞
			async blogLike () {
				if (!this.alreadyLogged) {
					this.needLogin()
        } else {
					let { token } = this.$route.params
					let { my_status } = this.blogDetail
					let res = await this.$api.blog.updateBlogLike(token, { is_like: !my_status.has_liked })
					if (res.code === 1000) {
            if (my_status.has_liked){
              this.showToast('已取消点赞',1500);
            }else {
              this.showToast('已点赞',1500);
            }
						my_status.has_liked = !my_status.has_liked
						my_status.has_liked ? this.blogDetail.like_count += 1 : this.blogDetail.like_count -= 1
					}
        }
			},
			// 获取攻略详情
			async getBlogDetail (token) {
				let res = await this.$api.blog.getBlogDetail(token)
				if (res.code === 1000) {
          this.blogDetail = res.data
          await this.$route.meta.shareByWx(`最全求职攻略！Mark起来慢慢看${new Date().getFullYear()} 最新求职干货，简历、面试全流程攻略，各行业笔试面经合集`, { title: this.blogDetail.title})
        }
			},
			// 获取热门文章列表
			async getHotPages () {
				let res = await this.$api.blog.getHotPages()
				if (res.code === 1000) this.hotPages = res.data.hot_pages
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";
  .blog-detail-container {
    background-color: #f9f9f9;
    @include mobile-container(44px, 50px);
    .mobile-nav {
      .iconfenxiang1 {
        font-size: 20px;
        font-weight: 500;
      }
    }
    .title-image {
      width: 100vw;
    }
    .blog-detail-content {
      padding: 16px 24px;
      background-color: $color-light;
      margin-bottom: 8px;
      .blog-detail-title {
        font-size: $font-size-large;
        color: $color-title;
        line-height: 26px;
        margin-bottom: 8px;
      }
      .detail-info {
        margin-bottom: 24px;
        .detail-time {
          color: #9c9c9c;
          margin-right: 16px;
        }
        .detail-author {
          color: #4183FF;
        }
      }
      .blog-detail-description {
        /deep/ * {
          width: calc(100vw - 48px) !important;
          line-height: 20px;
          /*margin: 0 !important;*/
          /*padding: 0 !important;*/
        }
        /deep/ ul, /deep/ ol {
          padding-left: 24px;
        }
        /deep/ p {
          margin-left: 0 !important;
        }
      }
    }
    .blog-hot-pages {
      background-color: $color-light;
      padding: 16px 24px;
      .hot-page-title {
        line-height: 20px;
        color: $color-title;
      }
      /deep/ .blog-item-container {
        padding: 16px 0;
        .blog-title {
          font-size: $font-size-medium;
        }
      }
    }
    .blog-footer {
      width: 100vw;
      background-color: $color-light;
      @include ipx-footer(50px, 15px);
      padding-top: 15px;
      .footer-item {
        flex: 1;
        font-size: $font-size-small;
        color: #9C9C9C;
        border-right: 1px solid #F9F9F9;
        &:last-child {
          border-right: none;
        }
        .iconfont {
          margin-right: 6px;
          font-size: 18px;
        }
        .icondianzan1 {
          color: $color-theme;
        }
        .iconyishoucang1 {
          color: rgb(255, 201, 47);
        }
      }
    }
  }
  .community-detail-topic {
    padding: 8px 16px;
    background-color: #FEFFFF;
    border: 1px solid #F4F4F4;
    border-radius: 4px;
    margin: 16px 24px;

    img {
      width: 42px;
      height: 42px;
      border-radius: 4px;
      margin-right: 10px;
      object-fit: cover;
    }

    .topic-info {
      justify-content: space-between;
      .title {
        font-size:16px;
        font-weight: 600;
        color: $color-dark-gray;
        margin-bottom: 10px;
      }

      .community-num {
        color: #9C9C9C;
        font-size: $font-size-small;
      }
    }

    .topic-detail {
      width: 60px;
      height: 26px;
      border-radius: 14px;
      background-color: #f4f4f4;
      color: #606060;
      font-size: $font-size-small;
    }
  }

</style>
